<template>
  <div id="December2024" class="202412 bg-center">
    <div class="fixed z-50 hidden xl:block" :class="{ 'fixed-btn': isMenu, 'hidden-btn': !isMenu}">
      <a class="block px-3">
        <img src="~@/assets/images/202412/menu/menu-off_01.png" class="object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan1')">
        <img src="~@/assets/images/202412/menu/menu-off_02.png" class="off object-contain">
        <img src="~@/assets/images/202412/menu/menu-on_02.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan2')">
        <img src="~@/assets/images/202412/menu/menu-off_03.png" class="off object-contain">
        <img src="~@/assets/images/202412/menu/menu-on_03.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#December2024')">
        <img src="~@/assets/images/202412/menu/menu-off_04.png" class="off object-contain">
        <img src="~@/assets/images/202412/menu/menu-on_04.png" class="on object-contain">
      </a>
    </div>
    <div class="logo py-6">
      <img src="~@/assets/images/202412/logo.png" class="object-contain mx-auto w-16 md:w-auto">
    </div>
    <div>
      <img src="~@/assets/images/202412/banner.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/202412/bannerM.png" class="object-contain mx-auto md:hidden">
    </div>
    <div class="mt-6 md:flex justify-center items-center md:-mt-24 xl:-mt-40">
      <div class="p-2">
        <img src="~@/assets/images/202412/plan1.png" class="object-contain mx-auto hidden md:block">
        <img src="~@/assets/images/202412/plan1M.png" class="object-contain mx-auto md:hidden">
      </div>
      <div class="p-2" @click="toTop('#plan1')">
        <img src="~@/assets/images/202412/plan2.png" class="object-contain mx-auto hidden md:block">
        <img src="~@/assets/images/202412/plan2M.png" class="object-contain mx-auto md:hidden">
      </div>
      <div class="p-2" @click="toTop('#plan2')">
        <img src="~@/assets/images/202412/plan3.png" class="object-contain mx-auto hidden md:block">
        <img src="~@/assets/images/202412/plan3M.png" class="object-contain mx-auto md:hidden">
      </div>
    </div>
    <div class="plan pt-20 md:pt-24">
      <div class="plan1 px-2 max-w-6xl mx-auto mb-32" id="plan1">
        <div class="plan1_inner border-4 rounded-xl border-red-decem bg-white p-4 plan-boxshaqow">
          <a target="_blank" class="md:-mt-16 lg:-mt-20 mb-6" href="https://store.liveabc.com/products/magazine/sale?tag=434">
            <img src="~@/assets/images/202412/p1.png" class="object-contain mx-auto hidden md:block">
            <img src="~@/assets/images/202412/p1M.png" class="object-contain mx-auto md:hidden">
          </a>
          <div class="flex flex-wrap mb-8">
            <a target="_blank" class="w-full md:w-1/2 p-4 border-b-4 border-red-decem pb-8" href="https://store.liveabc.com/magazine/detail/9140">
              <img src="~@/assets/images/202412/hiw.png" class="object-contain mx-auto">
            </a>
            <a target="_blank" class="w-full md:w-1/2 p-4 border-b-4 border-red-decem pb-8" href="https://store.liveabc.com/magazine/detail/9136">
              <img src="~@/assets/images/202412/abc.png" class="object-contain mx-auto">
            </a>
          </div>
          <!-- <div class="border-b-4  border-red-decem pt-10 mb-10 h-0"></div> -->
          <div class="flex flex-wrap">
            <a target="_blank" class="w-1/2 md:w-1/4 p-2 md:p-3" href="https://store.liveabc.com/magazine/detail/9138">
              <img src="~@/assets/images/202412/cnn.png" class="object-contain mx-auto">
            </a>
            <a target="_blank" class="w-1/2 md:w-1/4 p-2 md:p-3" href="https://store.liveabc.com/magazine/detail/9139">
              <img src="~@/assets/images/202412/jp.png" class="object-contain mx-auto">
            </a>
            <a target="_blank" class="w-1/2 md:w-1/4 p-2 md:p-3" href="https://store.liveabc.com/magazine/detail/9137">
              <img src="~@/assets/images/202412/live.png" class="object-contain mx-auto">
            </a>
            <a target="_blank" class="w-1/2 md:w-1/4 p-2 md:p-3" href="https://store.liveabc.com/magazine/detail/9135">
              <img src="~@/assets/images/202412/all.png" class="object-contain mx-auto">
            </a>
          </div>
        </div>
      </div>
      <div class="plan2 px-2 max-w-6xl mx-auto mb-20" id="plan2">
        <div class="plan2_inner border-4 rounded-xl border-red-decem p-4 plan-boxshaqow">
          <a target="_blank" class="md:-mt-16 lg:-mt-20" href="https://store.liveabc.com/products/magazine/sale?tag=442">
            <img src="~@/assets/images/202412/p2.png" class="object-contain mx-auto hidden md:block">
            <img src="~@/assets/images/202412/p2M.png" class="object-contain mx-auto md:hidden">
          </a>
          <a target="_blank" class="py-4 check z-10" href="https://store.liveabc.com/products/magazine/sale?tag=442">
            <img src="~@/assets/images/202412/chack.png" class="object-contain mx-auto z-10 block">
          </a>

          <div class="flex flex-wrap">
            <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" target="_blank" class="w-1/2 md:w-1/3 p-6 md:p-8" v-for="(item, index) in bookData" :key="index">
              <img :src="item.img_url" class="object-contain mx-auto mb-4">
              <img :src="item.img_url2" class="object-contain mx-auto">
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="footer text-white">
      <div class="wave">
      </div>
      <div class="footer-inner">
        <div class="max-w-5xl text-center mx-auto font-semibold leading-loose mb-10 px-4">
          <p class="text-lg mb-1">注意事項</p>
          <p class="text-sm">活動時間2024.11.1~12.31於LiveABC官方網站下單消費，即可參加抽獎活動，訂單成立並完成付款後即符合抽獎資格，一筆訂單可以參與抽獎一次。將於2025.1.20抽出1名得主，公告於LiveABC官方網站及官方臉書粉絲團。活動期間產生之訂單取消、退貨、交易失敗等條件，將失去參與本活動之資格，不予另行通知。活動內容以LiveABC官網發布為主。本公司保留活動修改、變更之權利。</p>
        </div>
        <router-link :to="{ name: 'index' }" class="block p-2 pb-10" target="_blank">
          <img src="~@/assets/images/202412/btn.png" class="object-contain mx-auto">
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import jump from 'jump.js'
export default {
  name: 'October2024',
  metaInfo () {
    return {
      title: '下單就抽11111元現金💰LiveABC年終折扣季',
      titleTemplate: null
    }
  },
  data () {
    return {
      isMenu: true,
      magData: [
        { text: '多益雅思補充教材', name: 'CNN互動英語', img_url: require('@/assets/images/202411/cnn-cover.png') },
        { text: '自學日語檢測必看', name: '互動日本語', img_url: require('@/assets/images/202411/jp-cover.png') },
        { text: '高中升學GEPT中級', name: 'Live互動英語', img_url: require('@/assets/images/202411/live-cover.png') },
        { text: '考大學GEPT中高級', name: 'ALL+互動英語', img_url: require('@/assets/images/202411/all-cover.png') }
      ],
      bookData: [
        { id: 7993, img_url: require('@/assets/images/202412/book/suit-01.png'), img_url2: require('@/assets/images/202412/book/1.png') },
        { id: 8728, img_url: require('@/assets/images/202412/book/suit-02.png'), img_url2: require('@/assets/images/202412/book/2.png') },
        { id: 7796, img_url: require('@/assets/images/202412/book/suit-03.png'), img_url2: require('@/assets/images/202412/book/3.png') },
        { id: 9622, img_url: require('@/assets/images/202412/book/suit-04.png'), img_url2: require('@/assets/images/202412/book/4.png') },
        { id: 8733, img_url: require('@/assets/images/202412/book/suit-05.png'), img_url2: require('@/assets/images/202412/book/5.png') },
        { id: 8248, img_url: require('@/assets/images/202412/book/suit-06.png'), img_url2: require('@/assets/images/202412/book/6.png') },
        { id: 7800, img_url: require('@/assets/images/202412/book/suit-07.png'), img_url2: require('@/assets/images/202412/book/7.png') },
        { id: 7388, img_url: require('@/assets/images/202412/book/suit-08.png'), img_url2: require('@/assets/images/202412/book/8.png') },
        { id: 6565, img_url: require('@/assets/images/202412/book/suit-09.png'), img_url2: require('@/assets/images/202412/book/9.png') },
        { id: 6568, img_url: require('@/assets/images/202412/book/suit-10.png'), img_url2: require('@/assets/images/202412/book/10.png') },
        { id: 9624, img_url: require('@/assets/images/202412/book/suit-11.png'), img_url2: require('@/assets/images/202412/book/11.png') },
        { id: 10242, img_url: require('@/assets/images/202412/book/suit-12.png'), img_url2: require('@/assets/images/202412/book/12.png') }
      ]
    }
  },
  mounted () {
  },
  methods: {
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#December2024 {
  background-color: rgb(255, 249, 243);
  .logo {
    background: rgba(221, 52, 52, 1);
  }
  .border-red-decem {
    border-color: rgba(221, 52, 52, 1);
  }
  .plan-boxshaqow {
    box-shadow: 25px 25px 0px 0px rgba(41, 47, 68, 0.3);
    @media (max-width: 768px) {
      box-shadow: 6px 6px 0px 0px rgba(41, 47, 68, 0.35);
    }
  }
  .plan {
    background: url('~@/assets/images/202412/BABO-01.png'),
    url('~@/assets/images/202412/BABO-02.png'),
    url('~@/assets/images/202412/BABO-03.png'),
    url('~@/assets/images/202412/BABO-04.png'),
    url('~@/assets/images/202412/BABO-05.png');
    background-position: top 0 right 0, top 5% left 0, top 30% right 0, top 65% left 0, top 90% right 0;
    background-repeat: no-repeat;
    @media (max-width: 768px) {
      background: none;
    }
  }
  .plan2 {
    .plan2_inner {
      background: rgba(255, 237, 222, 1);
      @media (max-width: 768px) {
        background: white;
      }
    }

    .check {
      position: relative;
      &:after {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        height: 4px;
        background: rgba(221, 52, 52, 1);
        z-index: -1;

        @media (max-width: 768px) {
          display: none;
        }
      }
    }
  }
  .hover-item {
    .on {
      display: none;
    }
    &:hover {
      .off {
        display: none;
      }
      .on {
        display: block;
      }
    }
  }
  .toggle-btn {
    top: 20%;
    left: -50%;
  }
  .fixed-btn {
    top: 50%;
    transform: translateY(-50%);
    left: 0%;
    transition: 0.3s;
  }
  .hidden-btn {
    top: 50%;
    transform: translateY(-50%);
    left: -174px;
    transition: 0.3s;
  }

}

.footer-inner {
  background: rgba(221, 52, 52, 1);
}
.wave {
  height: 75px;
  width: 100%;
  background: url('~@/assets/images/202412/wave.png');
  background-position: bottom center;
  background-repeat: repeat-x;
  background-size: contain;
  @media (max-width: 768px) {
    background-size: cover;
  }
}
</style>
